var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAbcdAckoInsuranceLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 21,
    viewBox: "0 0 86 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2372_3408)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.9817 3.45032H39.6495L45.4954 17.0688H41.4149L40.4147 14.6539H35.1185L34.138 17.0688H30.1357L35.9817 3.45032ZM39.3166 11.7378L37.7862 7.89289L36.2362 11.7378H39.3166Z",
    fill: "#2C2067"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5918 10.3465V10.308C44.5918 6.36673 47.6722 3.27698 51.8294 3.27698C54.6341 3.27698 56.4387 4.43546 57.6559 6.09681L54.7924 8.28028C54.0076 7.31464 53.1054 6.69611 51.7903 6.69611C49.8683 6.69611 48.5141 8.2996 48.5141 10.2694V10.308C48.5141 12.3357 49.8683 13.9199 51.7903 13.9199C53.2228 13.9199 54.0664 13.2627 54.8903 12.2778L57.7538 14.2862C56.4583 16.0439 54.7125 17.3389 51.6729 17.3389C47.7489 17.3389 44.5918 14.3826 44.5918 10.3465Z",
    fill: "#2C2067"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.9482 3.54688H62.7531V9.03382L67.4814 3.54688H71.9927L66.7945 9.36158L72.1689 17.0689H67.5989L64.1464 12.0464L62.7531 13.5727V17.0689H58.9482V3.54688Z",
    fill: "#2C2067"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.041 10.3465V10.308C71.041 6.42457 74.2195 3.27698 78.4564 3.27698C82.694 3.27698 85.8332 6.38758 85.8332 10.2694V10.308C85.8332 14.1914 82.6544 17.3389 78.4175 17.3389C74.1799 17.3389 71.041 14.2283 71.041 10.3465ZM81.9478 10.3465V10.308C81.9478 8.35742 80.5154 6.65751 78.4175 6.65751C76.3189 6.65751 74.9452 8.31885 74.9452 10.2694V10.308C74.9452 12.2585 76.3776 13.9584 78.4564 13.9584C80.5352 13.9584 81.9478 12.297 81.9478 10.3465Z",
    fill: "#2C2067"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9098 7.54309V13.4574C25.9098 13.9121 25.7026 14.3041 25.2817 14.5757C20.0231 17.9691 16.0421 19.3942 14.6487 19.7911C12.7283 20.3389 11.7102 20.2811 11.5438 20.2699C8.03584 20.0208 2.12793 15.265 2.12793 15.265C2.12793 15.265 6.94924 16.425 18.088 11.2031C20.1764 10.2247 22.508 9.16746 25.2181 7.93028C25.2181 7.93028 25.8103 7.67806 25.9098 7.5447V7.54309Z",
    fill: "url(#paint0_linear_2372_3408)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6325 7.34217C25.6635 7.31643 25.7026 7.28266 25.7206 7.26016C25.745 7.22963 25.7662 7.19913 25.7793 7.16218C25.8152 7.06256 25.8038 6.93885 25.7467 6.84726C25.6439 6.68017 25.4709 6.56927 25.2817 6.44716C20.0231 3.05377 16.0421 1.62863 14.6487 1.23177C12.7283 0.683878 11.7102 0.741726 11.5438 0.752969C8.03584 1.00201 2.12793 5.75787 2.12793 5.75787C2.12793 5.75787 6.94923 4.59787 18.088 9.81966C18.447 9.98839 18.8125 10.1586 19.1861 10.3306L25.2719 7.551C25.2719 7.551 25.5787 7.38067 25.6325 7.33896V7.34217Z",
    fill: "url(#paint1_linear_2372_3408)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.77505 10.5056C7.78158 9.24438 7.94147 7.98147 8.23675 6.73306L8.27593 6.57718C6.08308 6.06945 4.46455 5.96179 3.49376 5.96179C2.69265 5.96179 2.26681 6.03412 2.1216 6.06465C1.86054 6.12088 1.67619 6.32657 1.54403 6.49849C0.759245 7.52355 0.310547 8.98407 0.310547 10.5056C0.310547 12.0272 0.759245 13.4893 1.54403 14.5128C1.67619 14.6847 1.86054 14.8887 2.1216 14.9465C2.26681 14.977 2.69265 15.0494 3.49376 15.0494C4.46455 15.0494 6.08146 14.9417 8.27593 14.434L8.23675 14.2782C7.94147 13.0298 7.78158 11.7669 7.77505 10.5056Z",
    fill: "url(#paint2_linear_2372_3408)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2372_3408",
    x1: 14.479,
    y1: 12.6026,
    x2: 17.0615,
    y2: 19.5361,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B99AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5427FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2372_3408",
    x1: 11.795,
    y1: 2.0303,
    x2: 16.4522,
    y2: 11.6053,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B99AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5427FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2372_3408",
    x1: 0.196336,
    y1: 10.4847,
    x2: 8.86002,
    y2: 10.5444,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A890FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#431DFF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2372_3408"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 86,
    height: 21,
    fill: "white",
    transform: "translate(0 -0.000244141)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbcdAckoInsuranceLogo);
export default __webpack_public_path__ + "static/media/abcd-acko-insurance-logo.322ede155162e1da1bd8f165bbb4e360.svg";
export { ForwardRef as ReactComponent };